export * from './Text';
export * from './Text.types';
export * from './Text.view';
export * from './Text.styles';
//# sourceMappingURL=index.js.map